export default "__VITE_ASSET__L_pV66lR__"